import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import dayjs from 'dayjs';

export const usePermits = () => {
  const [permits, setPermits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPermits = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('project_records')
        .select('*')
        .eq('record_type', 'Permit');

      if (!error) {
        setPermits(data);
      } else {
        console.error('Error fetching permits:', error);
      }

      setLoading(false);
    };

    fetchPermits();
  }, []);

  const today = dayjs();
  const expiringPermits = permits.filter(p => {
    return (
      p.expiration_date &&
      dayjs(p.expiration_date).diff(today, 'day') <= 15 &&
      dayjs(p.expiration_date).diff(today, 'day') >= 0
    );
  });

  return { permits, expiringPermits, loading };
};
